<template>
    <div class="request-viewing">
        <b-row class="justify-content-lg-center">
            <b-col
                cols="12"
                lg="9"
            >
                <p class="h4 color-mid-grey text-bold text-center mb-5">
                    Select one of the available slots on the calendar and provide any additional notes for your requested
                    viewing time. You will receive a notification on whether you have been successful with your request.
                </p>
            </b-col>
        </b-row>

        <h3 class="flex-grow-1 mb-4 text-center d-block d-sm-none">
            {{ calendarDate | moment('MMMM YYYY') }}
        </h3>

        <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
                <button
                    type="button"
                    @click="$refs.calendar.prev()"
                >
                    &laquo; Previous
                </button>
            </div>
            <h3 class="flex-grow-1 text-center d-none d-sm-block">
                {{ calendarDate | moment('MMMM YYYY') }}
            </h3>
            <div>
                <button
                    type="button"
                    @click="$refs.calendar.next()"
                >
                    Next &raquo;
                </button>
            </div>
        </div>

        <div class="d-flex justify-content-center mb-3">
            <div class="field-wrap mb-0 w-auto">
                <label
                    for="field-calendar-view"
                    class="sr-only"
                >
                    Calendar View
                </label>
                <div class="field-wrap__input field-wrap__input--select">
                    <select
                        id="field-calendar-view"
                        v-model="calendarView"
                        class="py-3"
                        name="field-calendar-view"
                    >
                        <option value="week">
                            Weekly
                        </option>
                        <option value="month">
                            Monthly
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <v-calendar
            ref="calendar"
            v-model="calendarDate"
            :end="calendarEndDate"
            :type="calendarView"
            class="mb-5"
            color="primary"
            first-interval="16"
            interval-count="26"
            interval-minutes="30"
            @click:date="calendarView = 'week'"
        >
            <template
                #dayHeader="{ month }"
            >
                <div
                    class="px-2"
                >
                    {{ $moment(month, 'M').format('MMMM') }}
                </div>
            </template>

            <template
                #interval="{ date, time, past, future }"
            >
                <ViewingSlot
                    :date="date"
                    :time="time"
                    :past="past"
                    :future="future"
                    :end-date="calendarEndDate"
                    :availabilities="property.availabilities"
                    :date-selected="dateSelected"
                    :time-selected="timeSelected"
                    @click:slot="selectViewingSlot"
                />
            </template>
        </v-calendar>

        <b-collapse
            id="selected-fields-collapse"
            v-model="timeClicked"
        >
            <h4 class="color-mid-grey text-bold mb-4">
                Requested Date and Time
            </h4>

            <b-row>
                <b-col>
                    <div class="field-wrap">
                        <div class="field-wrap__input">
                            <input
                                id="field-day-selected"
                                v-model="dateSelected"
                                name="field-day-selected"
                                readonly
                            >
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="field-wrap">
                        <div class="field-wrap__input">
                            <input
                                id="field-time-selected"
                                v-model="timeSelected"
                                name="field-time-selected"
                                readonly
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>

            <!-- Field: Notes -->
            <div class="field-wrap">
                <label
                    for="field-notes"
                    class="h4 color-mid-grey text-bold mb-4"
                >
                    Additional Notes
                </label>
                <div class="field-wrap__input">
                    <textarea
                        id="field-notes"
                        v-model="requestViewing.notes"
                        name="field-notes"
                        rows="5"
                    />
                </div>
            </div>
            <!-- END Field: Notes -->

            <div class="text-center">
                <button
                    class="btn btn--primary m-auto"
                    @click="bookViewing()"
                >
                    Request Viewing
                </button>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import ViewingSlot from 'js/components/ViewingSlot';
// Times this property is available for viewings
// TODO: Restrict viewing requests so they can only be done > 1hr before current time
// TODO: Make this dynamically set on the property parent component

export default {
    name: 'RequestViewing',
    components: {
        'v-calendar': VCalendar,
        ViewingSlot
    },
    props: {
        property: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            requestViewing: {
                date: '',
                startTime: '',
                endTime: '',
                type: 'Viewing',
                address: '',
                name: '',
                telephone: '',
                email: '',
                notes: ''
            },
            timeClicked: false,
            timeSelected: '',
            dateSelected: '',
            calendarDate: this.$moment().format('YYYY-MM-DD'),
            calendarView: 'week'
        };
    },
    computed: {
        calendarEndDate() {
            return this.$moment().add(6, this.property.transaction_type === 'let' ? 'weeks' : 'months').format('YYYY-MM-DD');
        }
    },
    methods: {
        ...mapActions('properties', ['createViewingRequest']),
        selectViewingSlot(date, time) {
            // values used for user front end
            this.timeClicked = true;
            this.dateSelected = date;
            this.timeSelected = time;
            // values to be submitted to laravel DB
            const dateSelected = this.$moment(`${date} ${time}`);
            this.requestViewing.date = dateSelected.format('YYYY-MM-DD');
            this.requestViewing.startTime = dateSelected;
            this.requestViewing.endTime = dateSelected.clone().add(30, 'minute');
        },
        bookViewing() {
            this.createViewingRequest({
                id: this.property.id,
                type: 'viewing',
                start_at: this.requestViewing.startTime.toString(),
                end_at: this.requestViewing.endTime.toString(),
                request_message: this.requestViewing.notes
            })
                .then(() => {
                    this.$toasted.success('Your viewing request has been successfully sent');
                    this.$emit('success');
                })
                .catch(() => {
                    this.$toasted.error('Unable to submit your viewing request.');
                });
        }
    }
};
</script>

<style lang="scss">
.request-viewing {
    @include media-breakpoint-down(md) {
        .v-calendar-daily_head-day {
            font-size: 10px;
        }

        .v-calendar-daily_head-day-label {
            font-size: 14px;
        }

        .v-calendar-daily_head-weekday {
            font-size: 8px;
        }

        .v-calendar-daily_head-day {
            font-size: 10px;

            :last-child {
                display: none
            }
        }
    }
}
// availability
.availability {
    table-layout: fixed;
    width: 100%;
    border: 1px solid #f3f3f3;
    border-radius: global-var('rounded-corners');

    th, td {
        border: 1px solid #f3f3f3;
        padding: 2px 4px;
    }

    th {
        background: #f9f9f9;

        &[scope=col] {
            text-align: center;
        }

        @include media-breakpoint-down(sm) {
            font-size: 0.9rem;
        }
    }

    tbody {
        td {
            &.bookable {
                position: relative;
                background: #a9e2c4;
                cursor: pointer;
                vertical-align: middle;
                text-align: center;
            }

            &.unbookable {
                background: #d2d2d2 !important;
                pointer-events: none !important;
            }

            &.selected {
                background: theme-color('secondary');
            }
        }
    }
}
</style>
